import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Item, Indicator } from '@radix-ui/react-radio-group';
import radioButtonStyles from './BaseRadioButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * BaseRadioButton component - A customizable radio button input
 * @param {boolean} inverse - Apply inverse styling
 * @param {boolean} error - Apply error styling
 * @param {boolean} disabled - Disable the radio button
 */
const BaseRadioButton = React__default.forwardRef((_a, ref) => {
    var { className = "", disabled = false, inverse = false, error = false, value } = _a, props = __rest(_a, ["className", "disabled", "inverse", "error", "value"]);
    const { base, indicator } = radioButtonStyles({
        inverse,
        error,
        class: className,
        disabled,
    });
    return (jsx(Item, Object.assign({ ref: ref, className: cn(base(), className), "aria-disabled": disabled, disabled: disabled, value: value }, props, { children: jsx(Indicator, { className: indicator() }) })));
});
BaseRadioButton.displayName = "BaseRadioButton";

export { BaseRadioButton };
